import { Box, InputAdornment, TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ErrorMsg from "../../component/ErrorMsg/ErrorMsg";
import { Constant } from "../../Constant";
import { getForm, getIamsmartFieldMap } from "../../redux/selector";
import { isEmpty, isNotEmpty, isObjectNotEmpty } from "../../Utils";
export default function CustomTextField({
    label,
    inputProps,
    error,
    required = true,
    display = "flex",
    unit = "",
    prefixUnit = "",
    showError = true,
    fullWidth = false,
    toolTip = null,
    displayColon = true,
    ErrorMsgStyle = {},
    InputLabelProps = {},
    ...rest
}) {
    const [id, setId] = useState();
    const autofillOffList = Constant.autoCompleteOffList;
    const { formId } = useSelector(getForm());
    const isAutofillOff = autofillOffList.includes(formId);

    useEffect(() => {
        if (isNotEmpty(inputProps?.name)) {
            setId(inputProps.name);
        }
        if (isNotEmpty(inputProps?.label)) {
            setId(inputProps.label);
        }
        if (isNotEmpty(rest?.id)) {
            setId(String(rest.id).split(" ").join("_"));
        }
    }, [inputProps?.name, inputProps?.label, rest?.id]);
    const restProps = {
        rows: 1,
        ...rest,
        id,
    };
    const InputProps = {};
    if (isNotEmpty(unit)) {
        InputProps.endAdornment = (
            <InputAdornment position="end">{unit}</InputAdornment>
        );
    }
    if (isNotEmpty(prefixUnit)) {
        InputProps.startAdornment = (
            <InputAdornment position="start">{prefixUnit}</InputAdornment>
        );
    }
    const { t, i18n } = useTranslation();
    const iasFieldMap = useSelector(getIamsmartFieldMap());

    return (
        <TextField
            label={
                !isEmpty(label) && (
                    <Box display={display}>
                        {label}
                        {displayColon && (i18n.language === "en" ? ":" : "：")}
                        {required && (
                            <Box component="span" className="danger">
                                *
                            </Box>
                        )}
                        {isEmpty(toolTip) ? null : toolTip}
                    </Box>
                )
            }
            inputProps={inputProps}
            InputLabelProps={{ shrink: true, ...InputLabelProps }}
            error={isObjectNotEmpty(error)}
            helperText={
                showError ? (
                    <ErrorMsg message={error?.message} style={ErrorMsgStyle} />
                ) : null
            }
            style={fullWidth ? {} : { width: "80%" }}
            fullWidth
            {...restProps} //put the rest custom property into the component
            InputProps={{ ...InputProps, ...restProps.InputProps }}
            autoComplete={isAutofillOff ? "off" : "on"}
        />
    );
}